import { render } from "./About.vue?vue&type=template&id=3bdd9e61&ts=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=3bdd9e61&lang=scss"

import exportComponent from "E:\\xiangqukejidaima\\米优时官网\\miyoushi-web (3)\\miyoushi-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__